import {injectable, Inject} from 'inversify-props';
import HttpClient from "./http-client";

@injectable()
export class RouteStopsExtendedInfo {

    @Inject() httpClient: HttpClient;

    public getInfo(route: string) {
        return this.httpClient.post('/location/route_stops', {route})
            .then(res => {
                return res.data.response;
            });
    }

}